import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const createLoanEnquiry = async (enquiryData) => {
  console.log(enquiryData, "loan enquiry data");
  const response = await axios.post(`${base_url}loan-enquiry/`, enquiryData);
  return response.data;
};

const loanEnqService = {
  createLoanEnquiry,
};

export default loanEnqService;
